import { ApplicationEeoDataState } from './application-eeo-data-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByParam } from '../reducers/utils/state-manager';

const InitialState: ApplicationEeoDataState = {
  applicationEeoDataById: {},
  applicationEeoDataStateByApplicationId: {},
};

export const applicationEeoDataReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_APPLICATION_EEO_DATA'): {
      const { applicationId } = action.payload.args;
      return updateResourceByParam(
        state,
        'applicationEeoData',
        'applicationId',
        applicationId,
        true,
      );
    }
    case SUCCESS('LOAD_APPLICATION_EEO_DATA'): {
      const {
        args: { applicationId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'applicationEeoData',
        'applicationId',
        applicationId,
        false,
        { [applicationId]: data },
      );
    }
    case FAILURE('LOAD_APPLICATION_EEO_DATA'): {
      const { applicationId } = action.payload.args;
      return updateResourceByParam(
        state,
        'applicationEeoData',
        'applicationId',
        applicationId,
        false,
      );
    }
    default: {
      return state;
    }
  }
};
